import type { PreClaimsReasonTypesResponse } from './api';

export const normalizePreClaimsReasonTypes = (
  list: PreClaimsReasonTypesResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.reasonTypeDesc,
    value: row.reasonType,
  }));
};
